import React from "react";
import Accordion from "../../UI/Accordion";
import Button from "~/shared/ui/Fields/Button";
import s from "../Address.less";
import IconAutoFill from "~/components/Icons/autoFill";
import DynamicFormField from "../../UI/DynamicFormField";
import GeoField from "../GeoField";
import { addressFields } from "../helper";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { usePermissions } from "~/shared/context/PermissionContext";

const LadaAddress = ({
  isRu,
  autoFillAddress,
  dealerCoordinatsLadaSto,
  dealerInfoLadaSto,
  dealerCoordinatsLadaSale,
  dealerInfoLadaSale,
  allDisabled,
}) => {
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { t } = useTranslation();

  const canEditSale =
    hasPermission("dealer.updateAddress") ||
    hasPermission("dealer.updateAddress.lada.sale");

  const canEditSto =
    hasPermission("dealer.updateAddress") ||
    hasPermission("dealer.updateAddress.lada.sto");

  return (
    <>
      <div className={s.border}>
        <Accordion title="LADA">
          <div className={s.infoWrapper}>
            <div className={s.infoLeft}>
              <div className={s.title}>СТО</div>
              <div className={s.fullAddress}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Полный адрес:</div>
                  {hasPermission("dealer.updateAddress.lada.sto") && (
                    <Button
                      txtBtn={t("dealers.autoFill")}
                      onClick={() => autoFillAddress("ladaStoAddress")}
                      customClassName={s.autoFillButton}
                    >
                      <IconAutoFill />
                    </Button>
                  )}
                </div>
                <DynamicFormField
                  name="ladaStoAddressfullAddress"
                  label={t("dealers.fullAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <DynamicFormField
                name="ladaStoAddressindex"
                label={t("dealers.index")}
                type="text"
                className={clsx(s.itemIndex)}
                disabled={true || allDisabled}
              />
              {Object.entries(addressFields).map(
                ([field, settings]) => (
                  <GeoField
                    key={`ladaStoAddress${field}`}
                    prefix="ladaStoAddress"
                    field={field}
                    isRu={isRu}
                    allDisabled={!canEditSto}
                    {...settings}
                  />
                )
              )}
              <DynamicFormField
                name="ladaStoAddressoffice"
                label={t("dealers.office")}
                type="text"
                disabled={!canEditSto}
                className={clsx(s.itemIndex)}
              />
              <div className={s.borderSolo} />
              {dealerCoordinatsLadaSto.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  disabled={!canEditSto}
                />
              ))}
              <div className={s.borderSolo} />
              {dealerInfoLadaSto.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  // disabled={!canEditSto}
                  disabled
                />
              ))}
            </div>
            <div className={s.infoRight}>
              <div className={s.title}>Торговая точка</div>
              <div className={s.fullAddress}>
                <div className={s.blockTitle}>
                  <div className={s.title}>Полный адрес:</div>
                  {hasPermission("dealer.updateAddress.lada.sale") && (
                    <Button
                      txtBtn={t("dealers.autoFill")}
                      onClick={() => autoFillAddress("ladaSaleAddress")}
                      customClassName={s.autoFillButton}
                    >
                      <IconAutoFill />
                    </Button>
                  )}
                </div>
                <DynamicFormField
                  name="ladaSaleAddressfullAddress"
                  label={t("dealers.fullAddress")}
                  type="textarea"
                  customClassName={s.noneLabel}
                  className={s.bigInput}
                  disabled={true || allDisabled}
                />
              </div>
              <DynamicFormField
                name="ladaSaleAddressindex"
                label={t("dealers.index")}
                type="text"
                className={clsx(s.itemIndex)}
                disabled={true || allDisabled}
              />
              {Object.entries(addressFields).map(
                ([field, settings]) => (
                  <GeoField
                    key={`ladaSaleAddress${field}`}
                    prefix="ladaSaleAddress"
                    field={field}
                    isRu={isRu}
                    allDisabled={!canEditSale}
                    {...settings}
                  />
                )
              )}
              <DynamicFormField
                name="ladaSaleAddressoffice"
                label={t("dealers.office")}
                type="text"
                disabled={!canEditSale}
                className={clsx(s.itemIndex)}
              />
              <div className={s.borderSolo} />
              {dealerCoordinatsLadaSale.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  disabled={!canEditSale}
                />
              ))}
              <div className={s.borderSolo} />
              {dealerInfoLadaSale.map((field) => (
                <DynamicFormField
                  key={field.name}
                  {...field}
                  // allDisabled={!canEditSale}
                  allDisabled={true}
                />
              ))}
            </div>
          </div>
        </Accordion>
      </div>
    </>
  );
};

export default LadaAddress;
